import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Brand } from '../models/brand.model';

@Injectable({ providedIn: 'root' })
export class BrandService {
  readonly brand: Brand;

  constructor() {
    this.brand =
      environment.brands.find(({ host }) => host === window.location.hostname) ||
      environment.brands.find(({ isDefault }) => isDefault);
  }
}
